import styled from '@emotion/styled';

/**
 * Окно ленты: обычный горизонтальный скролл без полосы (листается тачпадом, тачем, мышью и стрелками),
 * края размыты, чтобы записи не обрывались по линейке.
 */
export const Viewport = styled.div`
  overflow-x: auto;
  scrollbar-width: none;
  cursor: grab;
  mask-image: linear-gradient(to right, transparent 0, #000 24px, #000 calc(100% - 24px), transparent 100%);

  &::-webkit-scrollbar {
    display: none;
  }

  &:active {
    cursor: grabbing;
    user-select: none;
  }

  @media (prefers-reduced-motion: reduce) {
    mask-image: none;
  }
`;
